export function createFeatureFactoryConfig(config: {
    [feature: string]: boolean;
}) {
    return function isFeatureEnabled(feature: string) {
        return config[feature];
    };
}

export function getFeatureFlag(
    envFlag: string | undefined,
    featureFlagName: string,
): boolean {
    return Boolean(envFlag?.split(',').includes(featureFlagName));
}
